import Mantra from "../Assets/Whats-App-Image-2024-12-21-at-20-06-24-e07c7dc9.webp";
import Barkha from "../Assets/Whats-App-Image-2024-12-27-at-12-41-48-eef19e49.webp";
import Mohan from "../Assets/image.webp";
import Rahul from "../Assets/image (1).webp";
import Hanu from "../Assets/image (2).webp";

export const Assets = {
  Mantra,
  Barkha,
  Mohan,
  Rahul,
  Hanu,
};
